
import { Mixins, Component, Watch } from 'vue-property-decorator';
import {
  Collapse,
  CollapseItem,
  Option,
  Select,
  Button,
} from 'element-ui';
import BsMixin from '@/views/Home/mixins/bsMixin';
import api from '@/api/set';
import { tSearch } from '@/components/Search/index';
import tData from './components/data.vue';
import bModal from './components/bModal.vue';

@Component({
  components: {
    Collapse,
    CollapseItem,
    Option,
    Select,
    Button,
    tData,
    bModal,
    tSearch,
  },
})

export default class normal extends Mixins(BsMixin) {
  private activeName: string = '';

  private searchValue: string = 'manage_help_manual';

  private title: string = '添加配置';

  private visible: boolean = false;

  private initType: string = 'manage_help_manual';

  public $ref!: {
    tData: tData,
  }

  public typeList: any = [];

  mounted() {
    api.getActivityBannerById('26')
  }

  handleSearchChange(v: any) {
    const type = v[0];
    this.initType = type;
    (this.$refs.tData as tData).getData(this.initType);
  }
}
